
<script>
    import { _ } from 'svelte-i18n';
    import { permissions } from '../stores/permissions.js'; 
    import { url } from '../stores/url.js'
    import { user } from '../stores/user.js'
    import { location, link } from 'svelte-spa-router'
    import { roles } from '../stores/roles.js'
    import { request } from '../functions/http-helpers.js';
    import { swalConfirm } from '../functions/html-helpers.js';
    import { onDestroy, onMount } from 'svelte';
    import UIkit from 'uikit';

</script>

<div style="background-color: var(--dark-primary); color: white;">
    {#if $user.id}
        <div class="uk-grid-collapse uk-grid-match" uk-grid>
            <div class="uk-width-1-3"> 
                <a
                    href="/overview" use:link
                    style="padding: 19px; {$location == '/overview' ? 'background: var(--primary); color: white;' : 'background: black; color: var(--primary);'}"
                    class="uk-flex uk-flex-middle uk-flex-center">
                    <!-- svgs -->  
                    <svg height="35" xmlns="http://www.w3.org/2000/svg" fill="{$location == '/overview' ? 'white' : 'var(--primary)'}" viewBox="0 0 512 512">
                        <path d="M152.1 38.2c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L7 113C-2.3 103.6-2.3 88.4 7 79s24.6-9.4 33.9 0l22.1 22.1 55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zm0 160c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L7 273c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l22.1 22.1 55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zM224 96c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32zM160 416c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-17.7 0-32-14.3-32-32zM48 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"/>
                    </svg>
			    </a>
            </div>
            <div class="uk-width-1-3">
                <a
                    href="/" use:link
                    style="padding: 19px; {$location == '/' ? 'background: var(--primary); color: white;' : 'background: black; color: var(--primary);'}"
                    class="uk-flex uk-flex-middle uk-flex-center">
                    <!-- svgs --> 
                    <svg height="35" xmlns="http://www.w3.org/2000/svg" fill="{$location == '/' ? 'white' : 'var(--primary)'}"  viewBox="0 0 512 512">
                        <path d="M256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"/>
                    </svg>
			    </a>
            </div>
            <div class="uk-width-1-3">
                <a 
                    href="/profil" use:link
                    style="padding: 19px; {$location == '/profil' ? 'background: var(--primary); color: white;' : 'background: black; color: var(--primary);'}"
                    class="uk-flex uk-flex-middle uk-flex-center">
                    <!-- svgs -->  
                    <svg
                        height="35" 
                        fill="{$location == '/profil' ? 'white' : 'var(--primary)'}" 
                        xmlns="http://www.w3.org/2000/svg" 
                        viewBox="0 0 448 512">
                        <path d="M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3z"/>
                    </svg>
			    </a>
            </div>
	    </div>
    {/if}
</div>